import { Injectable } from "@angular/core";
import { BehaviorSubject, from } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment'
import {
  FloorplannerAPI,
} from "src/app/models/Floorplanner.model";
import { EndPoints } from "../shared/endpoints.enum";
import { stringify } from "@angular/compiler/src/util";
// const axios = require("axios");

@Injectable({
  providedIn: "root",
})
export class FloorplannerService {

  editorApi = new BehaviorSubject<FloorplannerAPI>(null);
  editorApi$ = this.editorApi.asObservable();

  // currentProjectsList = new BehaviorSubject([]);
  // currentProjectsList$ = this.currentProjectsList.asObservable();

  // selectedProject = new BehaviorSubject(null);
  // selectedProject$ = this.selectedProject.asObservable();

  // selectedProjectProducts = new BehaviorSubject([]);
  // selectedProjectProducts$ = this.selectedProjectProducts.asObservable();

  // currentFloorplannerUser = new BehaviorSubject({});
  // currentFloorplannerUser$ = this.currentFloorplannerUser.asObservable();

  currentDiagram = new BehaviorSubject(null);
  currentDiagram$ = this.currentDiagram.asObservable();

  currentDesign = new BehaviorSubject(null);
  currentDesign$ = this.currentDesign.asObservable();

  constructor(
    public httpClient: HttpClient,
  ) {
    // this.getApiAuthToken()
  }
  // private floorplannerBaseUrl = environment.floorplanner.apiUrl;

  // config: any = {
  //   method: "GET",
  //   url: ``,
  //   headers: {
  //     "Content-Type": "application/json",
  //     "Authorization": `Basic ${btoa(`${environment.floorplanner.username}:${environment.floorplanner.password}`)}`,
  //   },
  //   data: {},
  // };

  // floorplannerPermissions: any = {
  //   user: {
  //     id: "57906297",
  //     permissions: ["save"],
  //     auth_token: '',
  //   },
  // }

  setFloorplannerAPI(api) {
    this.editorApi.next(api)
  }

  // setFloorplannerCurrentProjectProducts(res) {
  //   this.selectedProjectProducts.next(res);
  // }

  // setFloorplannerCurrentProject(res) {
  //   this.selectedProject.next(res);
  // }

  setFloorplannerCurrentDiagram(res) {
    this.currentDiagram.next(res);
  }

  // setFloorplannerCurrentDesign(res) {
  //   this.currentDesign.next(res);
  // }

  setDiagramDesign(designID) {
    this.editorApi.value.designId = designID;
  }

  // getMasterAuthDetails() {
  //   let auth = window.sessionStorage.getItem('f_auth');
  //   return JSON.parse(auth)
  // }

  // setMasterAuthToken(authResponse) {

  //   window.sessionStorage.setItem('f_auth', JSON.stringify({
  //     "authToken": `${authResponse.token}`,
  //     "authUser": `${authResponse.user_id}`
  //   }))

  //   this.config.params = {
  //     'auth_token': authResponse.token
  //   }

  //   this.floorplannerPermissions.user.auth_token = authResponse.token;

  // }

  // setUserAuthToken(authResponse) {

  //   let obj2 = this.floorplannerPermissions;

  //   obj2.user.id = stringify(authResponse.user_id)
  //   obj2.user.auth_token = stringify(authResponse.token)

  //   window.sessionStorage.setItem('f_user_auth', JSON.stringify({
  //     "authToken": `${authResponse.token}`,
  //     "authUser": `${authResponse.user_id}`
  //   }))

  //   this.config.params = {
  //     'auth_token': authResponse.token
  //   }
  //   this.floorplannerPermissions.user.id = stringify(authResponse.user_id);
  //   this.floorplannerPermissions.user.auth_token = authResponse.token;

  // }

  // getApiAuthToken() {
  //   this.config.url = EndPoints.FLOORPLANNER_TOKEN;

  //   const promise = new Promise((resolve, reject) => {
  //     axios(this.config)
  //       .then(function (response) {

  //         this.setMasterAuthToken(response.data)
  //         resolve(response.data)

  //       }.bind(this))
  //       .catch(function (error) {
  //         reject(error)
  //       });
  //   })

  //   return promise;

  // }

  // getUserAuthToken(userID) {
  //   this.config.method = "GET";
  //   this.config.url = `${environment.floorplanner.apiUrl}users/${userID}/token.json`;

  //   const promise = new Promise((resolve, reject) => {
  //     axios(this.config)
  //       .then(function (response) {

  //         this.setUserAuthToken(response.data)
  //         resolve(response.data)

  //       }.bind(this))
  //       .catch(function (error) {
  //         reject(error)
  //       });
  //   })

  //   return promise;

  // }

  createFloorplannerView(projectId, container, permissions): Promise<FloorplannerAPI> {
    const promise = new Promise((resolve, reject) => {
      (window as any)
        .entryPoint(container, projectId, permissions)
        .then(
          function (api) {
            (window as any).fpEditor = api;
            this.setFloorplannerAPI(api);
            resolve(api);
          }.bind(this)
        )
        .catch((error) => reject(error));
    });

    return promise;
  }

  // createFloorplannerUser(email, password, measurement_system) {
  //   this.config.method = "POST";
  //   this.config.url = `${this.floorplannerBaseUrl}users.json`;
  //   this.config.data = {
  //     user: {
  //       email: email,
  //       password: password,
  //       measurement_system: measurement_system,
  //     },
  //   };
  //   const observable = from(axios(this.config));
  //   return observable
  // }

  // fetchFloorplannerProjects() {
  //   this.config.url = EndPoints.FLOORPLANNER_PROJECTS;
  //   const observable = from(axios(this.config));
  //   return observable
  // }

  // createFloorplannerProject(name, description, userID) {
  //   this.config.method = "POST";
  //   this.config.url = `${this.floorplannerBaseUrl}projects.json`;
  //   this.config.data = {
  //     project: {
  //       name: name,
  //       description: description,
  //       user_id: userID,
  //     },
  //   };
  //   const observable = from(axios(this.config));
  //   return observable
  // }

  // fetchFloorplannerProject(projectID) {
  //   this.config.method = "GET";
  //   this.config.url = `${this.floorplannerBaseUrl}projects/${projectID}.json`;
  //   this.config.data = {};
  //   const observable = from(axios(this.config));
  //   return observable
  // }

  // fetchFloorplannerProjectProducts(projectID) {
  //   this.config.method = "GET";
  //   this.config.url = `${this.floorplannerBaseUrl}projects/${projectID}/products.json`;
  //   this.config.data = {};
  //   const observable = from(axios(this.config));
  //   return observable
  // }

  // createNewFloorplannerDiagram(projectID, floorID) {
  //   this.config.method = "POST";
  //   this.config.url = `${this.floorplannerBaseUrl}projects/${projectID}/floors/${floorID}/drawing.json`;
  //   this.config.data = {
  //     drawing: {
  //       project_id: projectID,
  //       floor_id: floorID,
  //     },
  //   };
  //   const observable = from(axios(this.config));
  //   return observable
  // }

  // fetchFloorplannerDiagram(projectID, floorID) {
  //   this.config.method = "GET";
  //   this.config.url = `${this.floorplannerBaseUrl}projects/${projectID}/floors/${floorID}/drawing.json`;
  //   this.config.data = {};
  //   const observable = from(axios(this.config));
  //   return observable
  // }

  // createNewFloorplannerDesign(
  //   projectID,
  //   floorID,
  //   designName = "Default Design"
  // ) {
  //   this.config.method = "POST";
  //   this.config.url = EndPoints.FLOORPLANNER_DESIGN;
  //   this.config.params = {
  //     ...this.config.params,
  //     project_id: projectID,
  //     floor_id: floorID,
  //   };
  //   this.config.data = {
  //     design: {
  //       name: designName,
  //     },
  //   };
  //   const observable = from(axios(this.config));
  //   return observable
  // }

}
